<nb-layout>
	<nb-sidebar class="p-0">
		<div class="column">
			<div>
				<p class="dark-paragraph">
					INDIVID
				</p>
				<div
					class="scenarios"
					routerLink="/scenario-one"
					routerLinkActive="active-link"
					[routerLinkActive]="['active', '']"
				>
					<p class="light-paragraph">
						<span class="span-text">
							• Skenari
						</span>
						1
					</p>

					<p class="light-paragraph-desc">
						Aksidentet e përsëritura në periudhën 1 vjeçare
					</p>
				</div>

				<div
					class="scenarios"
					routerLink="/scenario-two"
					routerLinkActive="active-link"
					[routerLinkActive]="['active', '']"
				>
					<p class="light-paragraph">
						<span class="span-text">
							• Skenari
						</span>
						2
					</p>
					<p class="light-paragraph-desc">
						Aksidentet e përsëritura në periudhën 2 vjeçare
					</p>
				</div>
				<div
					class="scenarios"
					routerLink="/scenario-three"
					routerLinkActive="active-link"
					[routerLinkActive]="['active', '']"
				>
					<p class="light-paragraph">
						<span class="span-text">
							• Skenari
						</span>
						3
					</p>
					<p class="light-paragraph-desc">
						Aksidentet e përsëritura në periudhën 2 vjeçare me më shumë persona
						të involvuar
					</p>
				</div>
			</div>
			<div>
				<p class="dark-paragraph">
					VETURA
				</p>
				<div
					class="scenarios"
					routerLink="/scenario-four"
					routerLinkActive="active-link"
					[routerLinkActive]="['active', '']"
				>
					<p class="light-paragraph">
						<span class="span-text">
							• Skenari
						</span>
						1
					</p>
					<p class="light-paragraph-desc">
						Aksidentet e përsëritura në periudhën 2 vjeçare
					</p>
				</div>
				<div
					class="scenarios"
					routerLink="/scenario-five"
					routerLinkActive="active-link"
					[routerLinkActive]="['active', '']"
				>
					<p class="light-paragraph">
						<span class="span-text">
							• Skenari
						</span>
						2
					</p>
					<p class="light-paragraph-desc">
						Aksidentet e makinave me pjesë të huazuara apo të vjedhura
					</p>
				</div>
			</div>
			<!-- <div
				class="scenarios"
				routerLink="/scenario-six"
				routerLinkActive="active-link"
			>
				<p class="dark-paragraph">
					Skenari
				</p>
				<span class="dark-paragraph">
					6
				</span>
			</div>
			<div
				class="scenarios"
				routerLink="/scenario-seven"
				routerLinkActive="active-link"
			>
				<p class="dark-paragraph">
					Skenari
				</p>
				<span class="dark-paragraph">
					7
				</span>
			</div>
			<div
				class="scenarios"
				routerLink="/scenario-eight"
				routerLinkActive="active-link"
			>
				<p class="dark-paragraph">
					Skenari
				</p>
				<span class="dark-paragraph">
					8
				</span>
			</div>
			<div
				class="scenarios"
				routerLink="/scenario-nine"
				routerLinkActive="active-link"
			>
				<p class="dark-paragraph">
					Skenari
				</p>
				<span class="dark-paragraph">
					9
				</span>
			</div>
			<div
				class="scenarios"
				routerLink="/scenario-ten"
				routerLinkActive="active-link"
			>
				<p class="dark-paragraph">
					Skenari
				</p>
				<span class="dark-paragraph">
					10
				</span>
			</div> -->
		</div>
	</nb-sidebar>

	<nb-layout-column class="colored-column-basic">
		<router-outlet></router-outlet>
	</nb-layout-column>
</nb-layout>
